<div [formGroup]="form()" class="flex flex-col gap-3">
  <div class="flex gap-4">
    <!-- Start Date & Time Pickers -->
    <div class="flex flex-col gap-1">
      @if (!floatingLabels()) {
        <span class="text-sm font-bold">
          {{ 'shared.dateTimeRangeFields.startDate' | translate }}
        </span>
      }

      <div class="flex gap-2">
        <div class="flex min-w-[180px] cursor-pointer" (click)="openStartPicker()">
          <mat-form-field
            class="flex-1 [&_input]:pointer-events-none mat-mdc-form-field-type-mat-date-picker"
            [class.active-datepicker]="startRangePicker?.opened"
          >
            @if (floatingLabels()) {
              <mat-label>{{ 'shared.dateTimeRangeFields.startDate' | translate }}</mat-label>
            }
            <input
              readonly
              matInput
              [value]="form().get('startDate')?.value | date: 'dd.MM.yyyy'"
              [placeholder]="'shared.dateTimeRangeFields.startDatePlaceholder' | translate"
            />

            <div matSuffix class="flex items-center gap-1">
              <app-icon src="icons/chevron-down.svg" [size]="20" />
            </div>
            <mat-date-range-picker #startRangePicker></mat-date-range-picker>
            <mat-error [control]="form().get('startDate')" />

            <div class="opacity-0">
              <mat-date-range-input
                #startRangeInput="matDateRangeInput"
                [rangePicker]="startRangePicker"
                [min]="minDate()"
                [max]="maxDate()"
              >
                <input matStartDate formControlName="startDate" />
                <input matEndDate formControlName="endDate" />
              </mat-date-range-input>
            </div>
          </mat-form-field>
        </div>

        <div class="flex min-w-[128px] cursor-pointer" (click)="openTimePicker(startTimePicker)">
          <mat-form-field
            class="flex-1 [&_input]:pointer-events-none"
            [class.active-datepicker]="startTimePicker?.isOpen()"
          >
            @if (floatingLabels()) {
              <mat-label>{{ 'shared.dateTimeRangeFields.startTimePlaceholder' | translate }}</mat-label>
            }
            <input
              matInput
              formControlName="startTime"
              [matTimepicker]="startTimePicker"
              [placeholder]="'shared.dateTimeRangeFields.startTimePlaceholder' | translate"
              (focus)="selectAllText($event)"
              (input)="onInputChange($event, startTimePicker)"
            />

            <div matSuffix class="flex items-center gap-1">
              <app-icon src="icons/chevron-down.svg" [size]="20" />
            </div>

            <mat-timepicker #startTimePicker [options]="startTimeFilteredOptions" />
            <mat-error [control]="form().get('startTime')" />
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- End Date & Time Pickers -->
    <div class="flex flex-col gap-1">
      @if (!floatingLabels()) {
        <span class="text-sm font-bold">
          {{ 'shared.dateTimeRangeFields.endDate' | translate }}
        </span>
      }

      <div class="flex gap-2">
        <div class="flex min-w-[180px] cursor-pointer" (click)="openEndPicker()">
          <mat-form-field
            class="flex-1 [&_input]:pointer-events-none mat-mdc-form-field-type-mat-date-picker"
            [class.active-datepicker]="endDatePicker?.opened"
          >
            @if (floatingLabels()) {
              <mat-label>{{ 'shared.dateTimeRangeFields.endDate' | translate }}</mat-label>
            }
            <input
              readonly
              matInput
              class="max-h-[48px]"
              [value]="form().get('endDate')?.value | date: 'dd.MM.yyyy'"
              [placeholder]="'shared.dateTimeRangeFields.endDatePlaceholder' | translate"
            />

            <div matSuffix class="flex items-center gap-1">
              <app-icon src="icons/chevron-down.svg" [size]="20" />
            </div>
            <mat-datepicker
              #endDatePicker
              [panelClass]="datePickerUtilities.endPickerPanelClass"
              [dateClass]="
                datePickerUtilities.endPickerDateClass(form().get('startDate')?.value, form().get('endDate')?.value)
              "
            ></mat-datepicker>
            <mat-error [control]="form().get('endDate')" />

            <div class="opacity-0">
              <input
                matInput
                [matDatepicker]="endDatePicker"
                [min]="form().get('startDate')?.value ?? null"
                [max]="maxDate()"
                [value]="form().get('endDate')?.value ?? null"
                (dateInput)="onRangeEndDateChange($event.value ?? null)"
              />
            </div>
          </mat-form-field>
        </div>

        <div class="flex min-w-[128px] cursor-pointer" (click)="openTimePicker(endTimePicker)">
          <mat-form-field
            class="flex-1 [&_input]:pointer-events-none"
            [class.active-datepicker]="endTimePicker.isOpen()"
          >
            @if (floatingLabels()) {
              <mat-label>{{ 'shared.dateTimeRangeFields.endTimePlaceholder' | translate }}</mat-label>
            }
            <input
              matInput
              formControlName="endTime"
              [matTimepicker]="endTimePicker"
              [placeholder]="'shared.dateTimeRangeFields.endTimePlaceholder' | translate"
              (focus)="selectAllText($event)"
              (input)="onInputChange($event, endTimePicker)"
            />

            <div matSuffix class="flex items-center gap-1">
              <app-icon src="icons/chevron-down.svg" [size]="20" />
            </div>

            <mat-timepicker #endTimePicker [options]="endTimeFilteredOptions" />
            <mat-error [control]="form().get('endTime')" />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
